import { Converter } from '../types/converter';

export const electricConductanceConverter: Converter = {
  id: 'electricConductance',
  name: 'Electric Conductance Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Siemens', symbol: 'S', factor: 1 },
    { name: 'Megasiemens', symbol: 'MS', factor: 1e6 },
    { name: 'Kilosiemens', symbol: 'kS', factor: 1000 },
    { name: 'Millisiemens', symbol: 'mS', factor: 0.001 },
    { name: 'Microsiemens', symbol: 'µS', factor: 1e-6 },
    
    // Alternative expressions
    { name: 'Ampere/volt', symbol: 'A/V', factor: 1 },
    
    // Historical units
    { name: 'Mho', symbol: '℧', factor: 1 },
    { name: 'Gemmho', symbol: 'gem℧', factor: 1e-12 },
    { name: 'Micromho', symbol: 'µ℧', factor: 1e-6 },
    
    // CGS units
    { name: 'Abmho', symbol: 'ab℧', factor: 1e9 },
    { name: 'Statmho', symbol: 'st℧', factor: 1.112650e-12 },
    
    // Quantum unit
    { name: 'Quantized Hall conductance', symbol: 'G₀', factor: 3.874046142e-5 }
  ]
};
